<template>
  <div>
    <div class="main_box">
      <div>
        <!--操作栏-->
        <el-form @submit.native.prevent :inline="true">
          <el-form-item>
            <el-form-item label="人员姓名：">
              <el-input v-model="searchForm.name" placeholder="请输入"></el-input>
            </el-form-item>
            <el-form-item label="联系方式：">
              <el-input v-model="searchForm.mobile" placeholder="请输入"></el-input>
            </el-form-item>
            <el-form-item label="单位部门：">
              <el-input v-model="searchForm.dept" placeholder="请输入"></el-input>
            </el-form-item>
            <el-button type="primary" @click="loadData">查询</el-button>
            <el-button @click="reset">重置</el-button>
          </el-form-item>
        </el-form>
      </div>
      <el-button icon="el-icon-plus" @click="save()" type="primary"> 新建</el-button>
    </div>
    <div class="main_box_table">
      <el-table :data="userList" border>
        <el-table-column prop="id" label="ID"></el-table-column>
        <el-table-column prop="name" label="姓名"></el-table-column>
        <el-table-column prop="mobile" label="联系方式"></el-table-column>
        <el-table-column prop="dept" label="单位部门"></el-table-column>
        <el-table-column prop="chargingCycles" label="日充电最大次数"></el-table-column>
        <el-table-column prop="createTime" label="创建时间 "></el-table-column>
        <el-table-column fixed="right" width="160px" label="操作">
          <template slot-scope="scope">
            <el-button type="text" @click="save(scope.row)">编辑</el-button>
            <el-button type="text" @click="save(scope.row,true)">详情</el-button>
            <el-button type="text" @click="deleteData(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="flex-r-e">
        <el-pagination
          v-show="total > 0"
          background=""
          layout="prev, pager, next, sizes, total, jumper"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="pageNum"
          :page-sizes="[5, 10, 15, 20]"
          :page-size="pageSize"
          :total="total"
        >
        </el-pagination>
      </div>
    </div>
    <!-- 添加编辑弹窗 -->
    <el-dialog
      :title="dialogTitle == 0 ? '添加用户' : '编辑用户'"
      :visible.sync="dialogVisible"
      append-to-body
      @close="dialogClose"
      width="430px"
    >
      <el-form
        :model="currentRole"
        ref="currentRole"
        :rules="rules"
        label-width="140px"
        class="demo-ruleForm"
      >
        <el-row>
          <el-col :span="24">
            <el-form-item label="姓名：" prop="name">
              <el-input :disabled="isDetail" placeholder="请输入" v-model="currentRole.name"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="联系方式：" prop="mobile">
              <el-input :disabled="isDetail" placeholder="请输入" v-model="currentRole.mobile"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="单位部门：" prop="dept">
              <el-input :disabled="isDetail" placeholder="请输入" v-model="currentRole.dept"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="日充电最大次数：" prop="chargingCycles">
              <el-input :disabled="isDetail" placeholder="请输入" v-model="currentRole.chargingCycles"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogClose" class="cancel-btn"
        >取 消</el-button
        >
        <el-button type="primary" @click="submitData('currentRole')"
        >确 定</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>
<script>
import api from "@/api";
var _self;
export default {
  data() {
    return {
      //分页
      pageNum: 1,
      pageSize: 10,
      total: 0,
      searchForm: {
        name: "",
        mobile: "",
        dept: ""
      },
      userList: [],
      isDetail:false,
      //弹窗
      dialogVisible: false,
      dialogTitle: 0, //新建为0，编辑为1,查看为2
      currentRole: {
        name: "",
        mobile: "",
        dept: "",
        chargingCycles: ""
      },
      rules: {
        name: [
          {
            required: true,
            message: "姓名不能为空！",
            trigger: "blur"
          }
        ],
        mobile: [
          {
            required: true,
            message: "电话号码不能为空！",
            trigger: "blur"
          }
        ],
        dept: [
          {
            required: true,
            message: "单位部门不能为空！",
            trigger: "blur"
          }
        ],
        chargingCycles: [
          {
            required: true,
            message: "充电次数不能为空！",
            trigger: "blur"
          }
        ]
      }
    };
  },
  created() {
    _self = this;
  },
  mounted() {
    _self.loadData();
  },
  methods: {
    dialogClose() {
      _self.dialogVisible = false;
      _self.isDetail = false
      if (_self.$refs.currentRole) {
        _self.$refs.currentRole.clearValidate();
        _self.$refs.currentRole.resetFields();
      }
    },
    dateChange() {
      if (_self.searchForm.applyDate == null) _self.searchForm.applyDate = [];
    },
    // 每页多少条
    handleSizeChange(val) {
      _self.pageSize = val;
      _self.loadData();
    },
    // 当前页
    handleCurrentChange(val) {
      _self.pageNum = val;
      _self.loadData();
    },
    loadData() {
      var pageSize = _self.pageSize;
      var pageNum = _self.pageNum;
      var searchForm = _self.searchForm;
      api.personalAPI
        .findQuery({
          pageSize: pageSize,
          pageNum: pageNum - 1,
          ...searchForm
        })
        .then(res => {
          if (res.status == 200) {
            if (res.data.content.length == 0 && res.data.total != 0) {
              _self.pageNum -= 1;
              _self.loadData();
              return;
            }
            _self.userList = res.data.content;
            _self.total = res.data.total;
          }
        });
    },
    reset() {
      _self.searchForm = _self.$options.data().searchForm;
      _self.loadData();
    },
    //添加
    save(row,isDetail) {
      if (row && !isDetail) {
        //编辑
        _self.dialogTitle = 1;
        _self.currentRole = JSON.parse(JSON.stringify(row));
      } else if (row && isDetail) {
        //详情
        _self.dialogTitle = 2;
        _self.isDetail = true;
        _self.currentRole = JSON.parse(JSON.stringify(row));
      } else {
        //添加
        _self.dialogTitle = 0;
        _self.currentRole = this.$options.data().currentRole;
      }
      _self.dialogVisible = true;
    },
    submitData() {
      this.$refs["currentRole"].validate(valid => {
        if (valid) {
          if(_self.dialogTitle == 0){
            api.personalAPI
              .createPersonal(_self.currentRole)
              .then(res => {
                if (res.status == 200) {
                  this.$message.success("操作成功");
                  _self.loadData();
                  _self.dialogVisible = false;
                } else {
                  this.$message.error(res.message);
                }
              })
              .catch(error => {
                console.log(error);
              });
          }else if(_self.dialogTitle == 1){
            api.personalAPI
              .updatePersonal(_self.currentRole)
              .then(res => {
                if (res.status == 200) {
                  this.$message.success("操作成功");
                  _self.loadData();
                  _self.dialogVisible = false;
                } else {
                  this.$message.error(res.message);
                }
              })
              .catch(error => {
                console.log(error);
              });
          }else {
            _self.dialogVisible = false;
          }
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    deleteData(row) {
      _self
        .$confirm("此操作将永久删除此项, 是否继续?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        })
        .then(() => {
          api.personalAPI
            .deletePersonal(row)
            .then(res => {
              if (res.status == 200) {
                this.$message.success("操作成功");
                _self.loadData();
              } else {
                this.$message.error(res.message);
              }
            })
            .catch(error => {
              console.log(error);
            });
        })
        .catch(() => {});
    }
  }
};
</script>
<style lang="scss" scoped>
.el-tree {
  border: 1px solid #D9D9D9 !important;
}
</style>
